import { render, staticRenderFns } from "./pg-p.vue?vue&type=template&id=3b0b5388&scoped=true&"
import script from "./pg-p.vue?vue&type=script&lang=js&"
export * from "./pg-p.vue?vue&type=script&lang=js&"
import style0 from "./pg-p.vue?vue&type=style&index=0&id=3b0b5388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b5388",
  null
  
)

export default component.exports